export default {
  mounted(el, binding) {
    const baseOpacity = binding.value?.baseOpacity ?? 0.5
    const endOpacity = binding.value?.endOpacity ?? 1
    const offset = binding.value?.offset ?? 0.0
    const duration = binding.value?.duration ?? 1.0

    const originalText = (el.textContent || "").trim()
    const words = originalText.split(/\s+/).filter(Boolean)

    el.textContent = ""
    const spans = words.map((w) => {
      const s = document.createElement("span")
      s.className = "reveal-word"
      s.textContent = w + " "
      s.style.opacity = String(baseOpacity)
      el.appendChild(s)
      return s
    })

    const update = () => {
      const rect = el.getBoundingClientRect()
      const vh = window.innerHeight || 1

      let p = (vh - rect.top) / vh // 0..1
      p = (p - offset) / duration
      p = Math.max(0, Math.min(1, p))

      const visibleCount = Math.floor(p * spans.length)

      for (let i = 0; i < spans.length; i++) {
        spans[i].style.opacity = i < visibleCount ? String(endOpacity) : String(baseOpacity)
      }
    }

    el.__revealWords__ = { update }

    window.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update)
    update()
  },

  beforeUnmount(el) {
    const state = el.__revealWords__
    if (!state) return
    window.removeEventListener("scroll", state.update)
    window.removeEventListener("resize", state.update)
    delete el.__revealWords__
  }
}